import { Component } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { AddNewPolicyMdl } from '../../Models/AddNewPolicy';
import { BindMdl } from '../../Models/BindMdl';
import { MotorProposal } from '../../Models/MotorProposal';
import { OnInit } from '@angular/core';
import { restURL } from '../../Models/restURL';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AddNewPolicyReqMdl } from '../../Models/AddNewPolicyReqMdl';
import { MotorDriverMdl } from '../../Models/MotorDriverMdl';
import { DriverLicenceReq, DriverLicenceRes } from '../../Models/DriverLicenceReq';
import { tplCoversPipe } from '../../Pipes/tplCoversPipe';
import { tplManCovers } from '../../Pipes/tplManCovers';
import { ProposalRes } from '../../Models/ProposalRes';



declare let $: any;
@Component({
  selector: 'InsuredInfo',
  templateUrl: './InsuredInfo.html',
  styleUrls: ['./InsuredInfo.css']
})
export class InsuredInfo implements OnInit {
  public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  ngOnInit() {

  }

  public AddNewPolicyObj: AddNewPolicyMdl = new AddNewPolicyMdl();
  public DriverRequired: boolean;
  public Titledesc: string;
  public ReviewInfo: boolean;
  public additionalDrivers: boolean;
  public CoverDetails: boolean;
  public HasComprehensive: boolean;
  public ShowPremium: boolean = false;

  public prObj: MotorProposal = new MotorProposal();
  public bindObj: BindMdl = new BindMdl();

  public driverObj: MotorDriverMdl = new MotorDriverMdl();
  //public proposalObj:MotorProposal=new MotorProposal();
  public newPolicyReq: AddNewPolicyReqMdl = new AddNewPolicyReqMdl();
  public isShowLoading: boolean = false;
  public DriverId: string;
  public DriverMM: string;
  public DriverDD: string;
  public DriverYY: string;

  public driverLicReq: DriverLicenceReq = new DriverLicenceReq();
  public driverLicRes: DriverLicenceRes = new DriverLicenceRes();
  public diverObj: MotorDriverMdl = new MotorDriverMdl();
  public IBAN1: string;
  public IBAN2: string;
  public IBAN3: string;
  public IBAN4: string;
  public IBAN5: string;
  public IBAN6: string;

  public prResObj: ProposalRes = new ProposalRes();
  constructor(private router: Router, private http: HttpClient, private url: restURL) {
    this.Titledesc = "Insured Details";
    this.BindInfo();
  }
  DriverSearch() {
    this.driverLicReq.DiverID = this.DriverId;
    this.driverLicReq.DOB = this.DriverDD + "-" + this.DriverMM + "-" + this.DriverYY;
    this.isShowLoading = true;
    this.http.post<DriverLicenceRes>(this.url.baseURL + "/DriverInfo/getDriverInfo", this.driverLicReq, this.httpOptions)
      .toPromise().then((result) => {
        this.driverLicRes = result;
        this.isShowLoading = false;
        if (this.driverLicRes.st.StatusCode == "F") {
          alert(this.driverLicRes.st.StatusDecEn);
        }
        else {
          this.diverObj.DriverNameAr = this.driverLicRes.Name;
          this.diverObj.DriverNameEn = this.driverLicRes.Name;
          this.diverObj.DriverLic_ExpiryDate = this.driverLicRes.LicenceExpiryDateH;
          this.diverObj.DriverLicenseNo = this.DriverId;
          this.diverObj.DriverDOB = this.DriverDD + "-" + this.DriverMM + "-" + this.DriverYY;
          // alert(this.driverLicRes.LicenceExpiryDateH);
          // alert(this.driverObj.DriverLic_ExpiryDate);
        }
        // alert(JSON.stringify(this.driverLicRes));
      },
        (error) => {
          this.isShowLoading = false;
          alert("Please Try agian Later")
        });

  }
  test() {

  }
  AddNewDriver() {
    let newDriverObj: MotorDriverMdl = new MotorDriverMdl();
    let DriverLicCount: number = 0;
    let DriverCount: number = 0;
    let mainDriverCount: number = 0;

    DriverCount = this.prObj.driverListObj.length;
    if (DriverCount > 3) {
      alert("You can't add more than three drivers")

    }
    else {
      DriverLicCount = this.prObj.driverListObj.filter(t => t.DriverLicenseNo == this.diverObj.DriverLicenseNo).length;
      if (DriverLicCount == 0) {
        mainDriverCount = this.prObj.driverListObj.filter(t => t.Ismaindriver == this.diverObj.Ismaindriver).length;
        if (mainDriverCount > 0) {
          alert("Only one main Driver is allowed to add");

        }
        else {
          newDriverObj.Ismaindriver = this.diverObj.Ismaindriver;
          newDriverObj.DriverLicenseNo = this.diverObj.DriverLicenseNo;
          newDriverObj.DriverDOB = this.diverObj.DriverDOB;
          if (this.diverObj.Ismaindriver == "1") {
            newDriverObj.isMainDriverEn = "Yes";
            newDriverObj.isMainDriverEn = "Yes";
          }
          else if (this.diverObj.Ismaindriver == "2") {
            newDriverObj.isMainDriverEn = "No";
            newDriverObj.isMainDriverEn = "No";
          }
          newDriverObj.DriverNameAr = this.diverObj.DriverNameAr;
          newDriverObj.DriverNameEn = this.diverObj.DriverNameEn;
          newDriverObj.DriverLic_ExpiryDate = this.diverObj.DriverLic_ExpiryDate;

          newDriverObj.DriverNationalityEn = this.bindObj.NationalityMasterList.filter(t => t.NationalityDesc == this.diverObj.DriverNationality)[0].NationalityDescEn;
          newDriverObj.DriverNationalityAr = this.bindObj.NationalityMasterList.filter(t => t.NationalityDesc == this.diverObj.DriverNationality)[0].NationalityDescAr;

          newDriverObj.DriverLicenseTypeEn = this.bindObj.LicenceTypeList.filter(t => t.LicTypecode == Number(this.diverObj.DriverLicenseType))[0].LicType_DescEn;
          newDriverObj.DriverLicenseTypeAr = this.bindObj.LicenceTypeList.filter(t => t.LicTypecode == Number(this.diverObj.DriverLicenseType))[0].LicType_DescAr;
          newDriverObj.DriverMaritalStatusEn = this.bindObj.MarStatusList.filter(t => t.MarstatusCode == this.diverObj.DriverMaritalStatus)[0].MarstatusDesc_En;
          newDriverObj.DriverMaritalStatusAr = this.bindObj.MarStatusList.filter(t => t.MarstatusCode == this.diverObj.DriverMaritalStatus)[0].MarstatusDesc_Ar;
          this.prObj.driverListObj.push(newDriverObj);
        }
      }
      else {
        alert("Driver Licence No Already Existed");
      }
    }
    //alert(JSON.stringify(this.prObj.driverListObj));
  }
  removeDriver(index) {
    this.prObj.driverListObj.splice(index, 1);
  }
  calcCompPremium() {
    let TotalPremium: number = 0;
    for (let cover of this.prObj.compCovers) {
      if (cover.isSelected === true) {
        TotalPremium = TotalPremium + cover.TotalPrice;

      }
    }

    this.prObj.CompGrossPremium = TotalPremium;
    if (this.prObj.CompNCDPercentage > 0) {
      TotalPremium = TotalPremium - this.prObj.CompNCDAmount;
    }
    if (this.prObj.CompLDAmount > 0) {
      TotalPremium = TotalPremium - this.prObj.CompLDAmount;
    }
    if (this.prObj.CompCrossSellDiscount > 0) {
      TotalPremium = TotalPremium - this.prObj.CompCrossSellDiscount;
    }
    if (this.prObj.PromoDiscount > 0) {
      TotalPremium = TotalPremium - this.prObj.PromoDiscount;
    }
    this.prObj.CompTotalPremiumBeforeVAT = TotalPremium;
    let VatAmt: number = 0;
    VatAmt = (TotalPremium * this.prObj.CompVAT_PERCENT) / 100;
    this.prObj.CompVAT_AMOUNT = VatAmt;
    TotalPremium = TotalPremium + VatAmt;
    this.prObj.CompTotalPremium = TotalPremium;

  }
  calcPremium() {
    let TotalPremium: number = 0;
    for (let cover of this.prObj.tplCovers) {
      if (cover.isSelected === true) {
        TotalPremium = TotalPremium + cover.TotalPrice;

      }
    }

    this.prObj.GrossPremium = TotalPremium;
    if (this.prObj.NCDPercentage > 0) {
      TotalPremium = TotalPremium - this.prObj.NCDAmount;
    }
    if (this.prObj.LDAmount > 0) {
      TotalPremium = TotalPremium - this.prObj.LDAmount;
    }
    if (this.prObj.CrossSellDiscount > 0) {
      TotalPremium = TotalPremium - this.prObj.CrossSellDiscount;
    }
    if (this.prObj.PromoDiscount > 0) {
      TotalPremium = TotalPremium - this.prObj.PromoDiscount;
    }
    this.prObj.TotalPremiumBeforeVAT = TotalPremium;
    let VatAmt: number = 0;
    VatAmt = (TotalPremium * this.prObj.VAT_PERCENT) / 100;
    this.prObj.VAT_AMOUNT = VatAmt;
    TotalPremium = TotalPremium + VatAmt;
    this.prObj.TotalPremium = TotalPremium;

  }
  DriverForm() {

    if (this.additionalDrivers) {
      this.Titledesc = "Add Driver"
      this.DriverRequired = true;
      this.ReviewInfo = false;
    }
    else {
      this.Review();
    }

  }
  modifyAdd() {
    //alert(this.prObj.addressObj.InsuredAddressType);
    if (this.prObj.addressObj.InsuredAddressType == "WaselAddress") {

    }
    else {

    }
  }
  BindInfo() {
    this.isShowLoading = true;
    this.newPolicyReq = JSON.parse(sessionStorage.getItem("newPolicyObj"));
    this.isShowLoading = true;
    this.http.post<BindMdl>(this.url.baseURL + "/newPolicy/bindInfo", this.newPolicyReq, this.httpOptions)
      .toPromise().then((result) => {
        this.bindObj = result;
        this.prObj = this.bindObj.MotorProposalObj;
        this.isShowLoading = false;
      },
        (error) => {
          this.isShowLoading = false;
          alert("Please Try agian Later")
        });
  }
  Back() {
    if (this.additionalDrivers) {
      this.DriverForm();
    }
    else {
      this.InsuredForm();
    }
  }

  InsuredForm() {
    this.additionalDrivers = false;
    this.ReviewInfo = false;
    this.Titledesc = "Insured Details"
    this.DriverRequired = false;
  }

  ProposalForm() {
    this.router.navigate(['./NewDashboard/ProposalForm']);
  }

  Review() {
    this.Titledesc = "Review & payment"
    this.DriverRequired = false;
    this.ShowPremium = true;
    //this.ReviewInfo=true;


  }

  PayMent() {
    alert("Redirecting to PayFort")
  }
  goForTPL() {
    this.prObj.ProductCode = "5515";
    this.prObj.SchemeCode = "1";
    this.saveProposal();
  }
  goforComp() {
    this.prObj.ProductCode = "5520";
    this.prObj.SchemeCode = "2";
    alert(JSON.stringify(this.prObj));
    this.saveProposal();
  }

  saveProposal() {
    this.isShowLoading = true;
    this.http.post<ProposalRes>(this.url.baseURL + "/Proposal/SaveProposal", this.prObj, this.httpOptions).
      toPromise().then((res) => {
        this.prResObj = res;
        alert(this.prResObj.st.StatusDesc);
        if (this.prResObj.st.StatusCode === "S") {
          this.router.navigate(['/NewDashboard/Proposals']);
        }
        this.isShowLoading = false;
      },
        (error) => {
          alert("Try again");
          this.isShowLoading = false;
        }
      )
  }
  onSelectionChange(evt: any) {
    if (evt.target.value == "Yes") {
      this.additionalDrivers = true;

    }
    else {
      this.additionalDrivers = false;
    }


  }
  ProceedCompre() {
    this.HasComprehensive = true;
  }
  onCoverSelectionChange(evt: any) {
    // if(evt.target.value=="Yes"){
    //   this.CoverDetails=true;
    //    }
    //    else{
    //     this.CoverDetails=false;
    //    }
  }

  ngAfterViewInit() {
    $(document).ready(function () {
      $(".addNew").addClass("active")
      $('[data-toggle="popover"]').popover({
        placement: 'top',
        trigger: 'hover'
      });
    })
  }

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/InsuredInfo/InsuredInfo.ts